var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("Error "+_vm._s(_vm.$route.params.code))])
}
var staticRenderFns = []

export { render, staticRenderFns }